import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import CreditPurchaseService from '../services/CreditPurchaseService';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
};

export const creditPurchaseList = createAsyncThunk('purchase/credit-purchase', async (payload) => {
  try {
    const resp = await CreditPurchaseService.CreditPurchaseList(payload);
    return resp;
  } catch (error) {
    return error.response;
  }
});

export const makePayment = createAsyncThunk('purchase/make-payment', async ({ data, navigate, config = {} }) => {
  try {
    const resp = await CreditPurchaseService.MakePayment(data, config);
    navigate(0);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Payment failed');
    return error.response;
  }
});

export const creditPaymentList = createAsyncThunk('purchase/credit-payment', async ({ perPage, page, keyword }) => {
  try {
    const resp = await CreditPurchaseService.CreditPaymentList({ perPage, page, keyword });
    return resp;
  } catch (error) {
    return error.response;
  }
});

export const creditPaymentItems = createAsyncThunk('purchase/credit-payment-items', async (id) => {
  
  try {
    const resp = await CreditPurchaseService.CreditPaymentItems(id);
    return resp;
  } catch (error) {
    return error.response;
  }
});

const creditPurchaseAction = createSlice({
  
  name: 'creditPurchase',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(creditPurchaseList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(creditPurchaseList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.purchases];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(creditPurchaseList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(makePayment.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(makePayment.fulfilled, (state, action) => {
        state.status = '';
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          state.status = 'achieve';
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(makePayment.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(creditPaymentList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(creditPaymentList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.payments];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(creditPaymentList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(creditPaymentItems.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(creditPaymentItems.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.data = action.payload?.data?.data?.items;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(creditPaymentItems.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      });
  },
});

const { reducer } = creditPurchaseAction;

export const creditPurchaseSelector = (state) => state.creditPurchase; 

export default reducer;
